import { AdManagementService } from '../client'

const API_ORIGIN = new URL(import.meta.env.VITE_API_URL ?? window.location.origin).origin
const POLL_INTERVAL = 500
const POPUP = 'width=600,height=800,menubar=no,toolbar=no'

type AuthMessage = { type?: string; message?: string }

export async function openMetaAuthPopup(brandId: number) {
  const { url } = await AdManagementService.getAuthUrl(brandId)
  const popup = window.open(url, 'meta-oauth', POPUP)
  if (!popup) throw new Error('Your browser blocked the Meta window. Allow pop-ups and try again.')

  await waitForMetaAuth(popup)
}

/** The callback page closes the popup itself, so a closed window means done, not failure. */
function waitForMetaAuth(popup: Window) {
  return new Promise<void>((resolve, reject) => {
    function finish(error?: string) {
      window.removeEventListener('message', onMessage)
      clearInterval(poll)
      popup.close()
      if (error) reject(new Error(error))
      else resolve()
    }

    function onMessage(event: MessageEvent<AuthMessage>) {
      if (event.origin !== API_ORIGIN) return
      if (event.data?.type === 'meta-auth-success') finish()
      if (event.data?.type === 'meta-auth-error') finish(event.data.message || 'Meta declined the request.')
    }

    const poll = setInterval(() => {
      if (popup.closed) finish()
    }, POLL_INTERVAL)

    window.addEventListener('message', onMessage)
  })
}
